import React from 'react';
import { LFC } from '../../Legacy';
import { useResolve } from '../Container';
import { ProfileModel } from '../ProfileModel';
import { Page, PageProps } from '../common/Page';
import { AccountModel } from './AccountModel';
import { NavigationView } from './navigation/NavigationView';

export const AccountPage: LFC<Omit<PageProps, 'navigation'>> = ({ children, ...props }) => {
    const user = useResolve(ProfileModel);
    const account = useResolve(AccountModel);
    return <>
        <div style={{ display: 'none' }} data-account={account.id} data-user={user.id} />
        <Page canton="/" {...props} navigation={NavigationView}>{children}</Page>
    </>;
};
